import {TicketEndTicketTimelineEvent} from '@ots-frontend/ots-data';
import {ActionIcon, Text} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {IconCircle} from "@tabler/icons-react";

type Props = {
  event: TicketEndTicketTimelineEvent;
  onClick?: (event: TicketEndTicketTimelineEvent) => void
};

export const EndTimelineItemTitle = (props: {}) => {
  const {t} = useTranslation(["common"])
  return <>{t("common.entity.transporttransportassoc.timeline.end.title", "Ended")}</>
}

export const EndTimelineItemBullet = (props: Props) => {
  const {event, onClick} = props;

  if (onClick) {
    return (
      <ActionIcon variant="transparent" onClick={() => onClick(event)}>
        <IconCircle size={12}/>
      </ActionIcon>
    )
  } else {
    return (
      <IconCircle size={12}/>
    )
  }
}

export const EndTimelineItem = (props: Props) => {
  const {event} = props;

  return (
    <>
      <Text size="xs" mt={4}>
        <FormattedDateTime date={event.date}/>
      </Text>
    </>
  );
};

EndTimelineItem.Title = EndTimelineItemTitle
EndTimelineItem.Bullet = EndTimelineItemBullet;
